
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Zum Beispiel Betablocker, die sonst als Blutdrucksenker verwendet werden. Auch
schwach dosiertes Aspirin (100 bis 300 Milligramm pro Tag (maximal 14 Tage pro
Monat), Botox-Spritzen und weitere Medikamente können vorbeugen, nicht alle
davon sind jedoch in der Schweiz für diesen Einsatz zugelassen. Von Zeit zu Zeit
ist ein Auslassversuch sinnvoll, um zu prüfen, ob der Effekt auch ohne
Medikamente anhält. In der Regel stoppt man daher die Medikation nach rund sechs
Monaten. Das oft verordnete Magnesium bringt übrigens – wenn überhaupt – nur
wenig gegen das Kopfweh, verursacht aber gelegentlich Durchfall.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;